import {
  extendedOnboardingMaxStepCount,
  standardOnboardingMaxStepCount,
} from '../../../../../constants/onboardingMaxStepCount'
import {
  extendedOnboardingStepCountMap,
  standardOnboardingStepCountMap,
} from '../../../../../constants/onboardingStepCount'
import { OnboardingVariant } from '../../../../../enums/onboardingVariant'
import { OnboardingSetupStep, OnboardingVariantType } from '../../../../../types'

interface GetOnboardingStepInfoProps {
  isExtendedQuestionnaire: boolean
  stepHistory: OnboardingSetupStep[]
  variant?: OnboardingVariantType
}

interface OnboardingStepInfo {
  isFirstStep: boolean
  progress: number
}

export const getOnboardingStepInfo = ({
  isExtendedQuestionnaire,
  stepHistory,
  variant,
}: GetOnboardingStepInfoProps): OnboardingStepInfo => {
  const currentStep = stepHistory[stepHistory.length - 1]
  const isFirstStep = stepHistory.length <= 1
  const isActiveVariant = variant && variant !== OnboardingVariant.Control
  const stepCountMap = isExtendedQuestionnaire ? extendedOnboardingStepCountMap : standardOnboardingStepCountMap
  const maxStepCount = isExtendedQuestionnaire ? extendedOnboardingMaxStepCount : standardOnboardingMaxStepCount
  const stepCount = isActiveVariant && currentStep ? (stepCountMap[currentStep] ?? 0) : 0
  const progress = isActiveVariant ? (stepCount / maxStepCount) * 100 : 0

  return { isFirstStep, progress }
}
